<template>
  <v-card>
    <v-tabs
      v-model="tab"
      background-color="blue-grey lighten-5"
    >
      <v-tab key="tab_configs">Configs</v-tab>
      <v-tab key="tab_tracks">Tracks</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab" class="mt-4">
      <v-tab-item key="tab_configs">
        <r-daily-bonus-configs/>
      </v-tab-item>
      <v-tab-item key="tab_tracks">
        <r-daily-bonus-tracks/>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import RDailyBonusConfigs from "@/modules/redactor/views/daily-bonus/r-daily-bonus-configs.vue";
import RDailyBonusTracks from "@/modules/redactor/views/daily-bonus/r-daily-bonus-tracks.vue";

export default {
  name: "r-daily-quest-page",
  components: {RDailyBonusTracks, RDailyBonusConfigs},
  data: () => ({
    tab: null
  })
}

</script>